import React from "react";
import { Button, Space } from "antd";
import { NavLink } from "react-router-dom";
import { useContext } from "react";
import { context } from "../../context/context";
import FeedBackTable from "./FeedBackTable";

const FeedBackSection = () => {
    // context
    const {
        setFeedBackAnswers,
        setFeedBackData,
        setFeedBackEndDate,
        setFeedBackEndText,
        setFeedBackQuestionText,
        setFeedBackStartDate,
        setFeedBackStartText,
        setFeedBackStepTwoId,
    } = useContext(context);
    // functions
    const handleEmptyFields = () => {
        setFeedBackAnswers([]);
        setFeedBackData([]);
        setFeedBackEndDate(null);
        setFeedBackEndText(null);
        setFeedBackQuestionText(null);
        setFeedBackStartDate(null);
        setFeedBackStartText(null);
        setFeedBackStepTwoId(null);
    };
    return (
        <>
            <Space
                direction="vertical"
                style={{ width: "100%", justifyContent: "space-between" }}
                align="end"
            >
                <NavLink to="/addFeedBack">
                    <Button onClick={handleEmptyFields} type="primary">
                        اضافه کردن نظرسنجی جدید
                    </Button>
                </NavLink>
            </Space>
            <FeedBackTable />
        </>
    );
};

export default FeedBackSection;
